import { Snackbar, IconButton, List, ListItem, ListItemText, ListItemSecondaryAction } from '@mui/material';
import { markNotificationAsRead, deleteNotification } from '../../services/notificationService';
import React, { useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';

const NotificationViewer = () => {
    const [notifications, setNotifications] = useState([]); // Mantener el estado de notificaciones
    const [open, setOpen] = useState(false); // Controlar manualmente la apertura del Snackbar

    const handleMarkAsRead = async (notificationId) => {
        try {
            await markNotificationAsRead(notificationId);
            setNotifications((prev) => prev.filter(notification => notification.id !== notificationId));
        } catch (error) {
            console.error('Error al marcar la notificación como leída:', error);
        }
    };

    const handleDelete = async (notificationId) => {
        try {
            await deleteNotification(notificationId);
            setNotifications((prev) => prev.filter(notification => notification.id !== notificationId));
        } catch (error) {
            console.error('Error al eliminar la notificación:', error);
        }
    };

    const handleClose = () => {
        setOpen(false); // Solo cerrar el Snackbar
    };

    return (
        <Snackbar
            open={open}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            sx={{ width: '400px', maxWidth: '100%' }}
        >
            <List sx={{ bgcolor: 'background.paper', borderRadius: '8px', boxShadow: 3 }}>
                {notifications.length > 0 ? (
                    notifications.map((notification) => (
                        <ListItem key={notification.id} sx={{ display: 'flex', alignItems: 'center' }}>
                            <ListItemText
                                primary={notification.title}
                                secondary={notification.body}
                            />
                            <ListItemSecondaryAction>
                                <IconButton
                                    edge="end"
                                    aria-label="mark-as-read"
                                    onClick={() => handleMarkAsRead(notification.id)}
                                >
                                    <span style={{ fontSize: '0.8rem', color: 'green' }}>✔</span>
                                </IconButton>
                                <IconButton
                                    edge="end"
                                    aria-label="delete"
                                    onClick={() => handleDelete(notification.id)}
                                >
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                    ))
                ) : (
                    <ListItem>
                        <ListItemText primary="No hay notificaciones no leídas" />
                    </ListItem>
                )}
            </List>
        </Snackbar>
    );
};

export default NotificationViewer;